import { render } from "./SelectPond.vue?vue&type=template&id=5772cd77&scoped=true&ts=true"
import script from "./SelectPond.vue?vue&type=script&lang=ts"
export * from "./SelectPond.vue?vue&type=script&lang=ts"

import "./SelectPond.vue?vue&type=style&index=0&id=5772cd77&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5772cd77"]])

export default __exports__